import { render, staticRenderFns } from "./BpButton.vue?vue&type=template&id=a4fb7ee0&scoped=true&"
import script from "./BpButton.vue?vue&type=script&lang=js&"
export * from "./BpButton.vue?vue&type=script&lang=js&"
import style0 from "./BpButton.vue?vue&type=style&index=0&id=a4fb7ee0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4fb7ee0",
  null
  
)

export default component.exports